import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Alert, AlertDescription } from '@/shared/components/ui/alert';
import { I18nNamespace } from '~/common/types';

interface LineItemAwardingConfirmationDialogContentProps {
  assignedAwardableLineItemsCount: number;
  dismissedAwardableLineItemsCount: number;
  i18nKeyPrefix: string;
}

export const AwardingConfirmationDialogContent = ({
  assignedAwardableLineItemsCount,
  dismissedAwardableLineItemsCount,
  i18nKeyPrefix,
}: LineItemAwardingConfirmationDialogContentProps) => {
  const { t } = useTranslation(I18nNamespace.widgets, { keyPrefix: i18nKeyPrefix });

  return (
    <div className="space-y-4">
      <p className="text-sm text-foreground">
        {t('summary', {
          count: assignedAwardableLineItemsCount,
        })}
      </p>

      <Alert variant="warning" className="text-warning border-warning/50 bg-warning/10  [&>svg]:text-warning">
        <AlertTriangle className="size-4" />
        <AlertDescription>
          {t('warning', {
            count: dismissedAwardableLineItemsCount,
          })}
        </AlertDescription>
      </Alert>
    </div>
  );
};
